export var REQ_ID_HISTORY_DATA = "REQ_ID_HISTORY_DATA";
export var REQ_ID_HISTORY_START_LOADER = "REQ_ID_HISTORY_START_LOADER";
export var REQ_ID_HISTORY_STOP_LOADER = "REQ_ID_HISTORY_STOP_LOADER";
export var REQ_ID_HISTORY_HIDE_ERROR = "REQ_ID_HISTORY_HIDE_ERROR";
export var REQ_ID_HISTORY_ERROR = "REQ_ID_HISTORY_ERROR";
